import type { ReportDefinition } from './types'

type Translate = (key: string, params?: Record<string, string | number>) => string

/**
 * Подпись колонки результата отчёта — одна для таблицы на экране и для файла выгрузки (#88).
 *
 * Мера подписывается полем и агрегатом («Выручка · сумма»), измерение — полем. Сервер
 * словаря не знает, поэтому подписи для файла собирает клиент, и собирает их этой же
 * функцией: иначе колонка в файле называлась бы не так, как в таблице, из которой его
 * выгрузили.
 */
export function reportColumnHeader(t: Translate, definition: ReportDefinition | null, column: string): string {
  const measure = definition?.measures.find((m) => m.alias === column)
  return measure
    ? `${t(`column.${measure.field}`)} · ${t(`report.aggregate.${measure.aggregate}`)}`
    : t(`column.${column}`)
}

/**
 * Подписи для запроса выгрузки: ключ колонки → подпись. Колонку без перевода не шлём —
 * сервер оставит её ключом, а ключ `column.x` в заголовке файла был бы хуже ключа `x`.
 */
export function reportExportHeaders(t: Translate, definition: ReportDefinition | null): Record<string, string> {
  if (!definition) return {}
  const columns = [...definition.dimensions, ...definition.measures.map((m) => m.alias)]
  const headers: Record<string, string> = {}
  for (const column of columns) {
    const measure = definition.measures.find((m) => m.alias === column)
    const field = measure ? measure.field : column
    if (t(`column.${field}`) === `column.${field}`) continue
    headers[column] = reportColumnHeader(t, definition, column)
  }
  return headers
}
